import { POINTS_CONFIG } from '../constants/game'
import { assetsImageLoader } from '../utils/funtions'
import BGPill from './bgPill'

export default class Points {
  /** @type Phaser.GameObjects.Image */
  container
  /** @type Phaser.GameObjects.Text */
  text
  /** @type Phaser.GameObjects.Image */
  icon
  /**
   * @type {{
   * context: Phaser.Scene,
   * }}
   **/
  config = {}

  /**
   * @param {Phaser.Scene} context
   */
  constructor(context) {
    this.config.context = context
  }

  preload() {
    assetsImageLoader(
      {
        icon: POINTS_CONFIG.iconSrc,
      },
      'points-',
      this.config.context
    )
  }

  create() {
    this.MINIMAP_CAM_ID = this.config.context.cameras.getCamera('minimap').id
    this.MEDIA_TYPE = this.config.context.data.get('mediaType')

    this.container = new BGPill(
      this.config.context,
      POINTS_CONFIG.posX[this.MEDIA_TYPE](
        this.config.context.game.config.width
      ),
      POINTS_CONFIG.posY[this.MEDIA_TYPE](
        this.config.context.game.config.height,
        this.config.context.game.config.width
      ),
      POINTS_CONFIG.displayWidth[this.MEDIA_TYPE]
    )

      .setScrollFactor(0)
      .setDepth(POINTS_CONFIG.depth)

    this.container.cameraFilter = this.MINIMAP_CAM_ID
    this.icon = this.config.context.add
      .image(
        this.container.x + 10,
        this.container.y + this.container.height / 2,
        'points-icon'
      )
      .setScrollFactor(0)
      .setOrigin(0, 0.5)
      .setDepth(POINTS_CONFIG.depth + 1)
    this.icon.cameraFilter = this.MINIMAP_CAM_ID

    this.text = this.config.context.add
      .text(
        this.container.x + 35,
        this.container.y + this.container.height / 2,
        POINTS_CONFIG.text,
        POINTS_CONFIG.style[this.MEDIA_TYPE]
      )
      .setOrigin(0, 0.5)
      .setScrollFactor(0)
      .setResolution(2)
      .setDepth(POINTS_CONFIG.depth + 1)

    this.text.cameraFilter = this.ID_CAM_FILTER
  }

  upload() {
    this.text.setText(
      POINTS_CONFIG.text.replace(
        '$',
        this.config.context.data.get('POINTS') + ''
      )
    )
  }
}
